import React from "react";
import {FormikProps} from "formik";
import {Grid, styled, TextField} from "@mui/material";
import {StandardTextFieldProps} from "@mui/material/TextField/TextField";
import {get} from "lodash";
import {getFormErrorText} from "../../utils/getFormTextError";
import {HELPER_TEXT_STYLES} from "./variable";
import {GridTypeMap} from "@mui/material/Grid/Grid";

export interface TextInputFieldProps extends StandardTextFieldProps {
    fieldName: string;
    form: FormikProps<any>;
    label: string;
    fullWidth?: boolean;
    isGridItem?: boolean;
    gridProps?: GridTypeMap["props"];
    enforceCorrectness?: (value: string) => string;
}

const StyledField = styled(TextField)`
    .MuiFormHelperText-root {
        ${HELPER_TEXT_STYLES}
    }
`;

const FormTextInputField = ({
    fieldName,
    label,
    form,
    fullWidth = true,
    isGridItem = false,
    gridProps = {xs: 6},
    enforceCorrectness,
    ...rest
}: TextInputFieldProps) => {
    const rawValue = get(form.values, fieldName);
    const value = enforceCorrectness && typeof rawValue === "string" ? enforceCorrectness(rawValue) : rawValue;
    const getField = () => (
        <StyledField
            fullWidth={fullWidth}
            id={`${fieldName}`}
            name={`${fieldName}`}
            value={value}
            label={label}
            onChange={(e) => {
                if (enforceCorrectness) {
                    const newValue = e.target.value;
                    const cleaned = enforceCorrectness(newValue);
                    form.setFieldValue(fieldName, cleaned);
                    if (rest.onChange) {
                        rest.onChange({
                            ...e,
                            target: {...e.target, value: cleaned},
                        });
                    }
                } else {
                    (rest.onChange ?? form.handleChange)(e);
                }
            }}
            onBlur={form.handleBlur}
            error={!!getFormErrorText(form, fieldName)}
            helperText={getFormErrorText(form, fieldName)}
            {...rest}
        />
    );

    return isGridItem ? (
        <Grid item {...gridProps}>
            {getField()}
        </Grid>
    ) : (
        getField()
    );
};

export default FormTextInputField;
